import { render, staticRenderFns } from "./Foods.vue?vue&type=template&id=bccd02d8&scoped=true&"
import script from "./Foods.vue?vue&type=script&lang=js&"
export * from "./Foods.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bccd02d8",
  null
  
)

export default component.exports